import React from 'react';
import { Link as GatsbyLink } from "gatsby";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import homePageStyles from '../home.module.css';
import sectionStyles from './index.module.css';
import { M3Backdrop } from '../HomeDecor';
import M3DevicesMockup from './M3DevicesMockup';

class M3Section extends React.Component {
  render() {
    return (
      <section className={`${homePageStyles.m3Section} section`}>
        <M3Backdrop />
        <Grid container spacing={0} className={`${sectionStyles.contentContainer} contentContainer`}>
          <Grid item xs={false} lg={2} xl={2} />
          <Grid item xs={12} lg={8} xl={8}>
            <div className={`sectionTitle`}>About Our Solutions</div>
            <div className={`sectionTitleUnderline ul-center`} />
            <div className={`articleBigTitle`}>
              M3 membership software
            </div>
            <div className={`${sectionStyles.articleTitle} articleTitle`}>
              Billing, members, and the front desk—together
            </div>
            <div>
              <p className={`${sectionStyles.generalArticle} generalArticle`}>
                M3 is membership and billing software for gyms and martial arts studios. We built it with owners: simple for everyday tasks, precise where your numbers and schedules matter—so admin stays small and your focus stays on members.
              </p>
            </div>
            <M3DevicesMockup />
            <Button variant="contained" className="m-top-20 m-bottom-20" component={GatsbyLink} to="/m3/">
              Learn More
            </Button>
          </Grid>
          <Grid item xs={false} lg={2} xl={2} />
        </Grid>
      </section>
    );
  }
}

export default M3Section;